import React, { useState } from 'react';
import { QrReader } from 'react-qr-reader';
import '../components/Cupons/cupons.css'; // Asegúrate de tener un archivo CSS para estilos

const QrScanner = ({ onScan, onClose }) => {
    const [error, setError] = useState(null);
    const [content, setContent] = useState("null");

    const handleScan = data => {
        if (data) {
            onScan(data);
            setContent(data);
            //console.log(`QR Code scanned: ${data}`);
        }
    };

    const handleError = err => {
        setError(err.message || 'Error al acceder a la cámara');
    };

    return (
        <div className="">
            
                <QrReader
                    constraints={{ facingMode: "environment" }}
                    onResult={(result, error) => {
                        if (!!result) handleScan(result?.text);
                        if (!!error) handleError(error);
                    }}
                    style={{ width: '100%' }}
                />
 
        </div>
    );
};

export default QrScanner;